<doc>
  @desc:   布局 - 我的赛事组件
  @author:  
</doc>
<template>
  <div class="my-league-wrapper" v-if="myLeagues.length > 0">
    <div class="league-title flex flex-align-center">
      <i class="league-title-icon icon-font icon-collectStar"></i>
      <h3 class="league-title-text">{{ langConfig.txtLang[langConfig.curLang]['MY_LEAGUES'] }}</h3>
    </div>
    <div class="league-item">
      <ul class="league-list">
        <li class="flex flex-align-center" v-for="(item, key) in myLeagues" :key="key">
          <img class="country-flag" :src="common.noCountryBack(item, 'img')" @error="common.imgError($event, 'country')" />
          <span><router-link :to="toLeague(item)" :class="toCss(item)">{{ item['fullName'] }}</router-link></span>
        </li>
        <!-- <li class="flex flex-align-center">
          <img class="country-flag" src="~@/assets/images/flag.png" />
          <span><router-link to="">English Premier League</router-link></span>
        </li>
        <li class="flex flex-align-center">
          <img class="country-flag" src="~@/assets/images/flag.png" />
          <span><router-link to="">English Premier League</router-link></span>
        </li>
        <li class="flex flex-align-center">
          <img class="country-flag" src="~@/assets/images/flag.png" />
          <span><router-link to="">English Premier League</router-link></span>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
  //import { mapState, mapMutations, mapActions } from 'vuex';

  export default {
    props: {
      myLeague: {
        type: Array,
        default: () => [],
      }
    },
    data(){
      return{
        myLeagues: [],
      }
    },
    computed: {
    },
    mounted(){
      // this.$watch('leagueData', (val) => {
      //   console.log(val); 
      //   this.myLeague = val;
      // });
    },
    methods: {
      getMyLeagueData(){
        let _myLeague = [];
        if(typeof(this.myLeague) != 'undefined'){
          _myLeague = this.common.jsonParse(this.myLeague);
        }

        if(_myLeague.length > 0){
          // a~z 排序
          _myLeague.sort((a, b) => a['fullName'] > b['fullName'] ? 1 : -1);

          this.myLeagues = _myLeague;
        }else{
          this.myLeagues = [];
        }
      },

      // 跳转联赛
      toLeague(val){
        let _leagueId = val.id, _hasDt = val['hasDt'];
        
        if(typeof(_hasDt) != 'undefined' && _hasDt){
          return '/leagues/' + _leagueId + '/0';
          //this.$router.push('/leagues/' + _leagueId + '/0');
        }else{
          return ''
        }
      },

      //样式
      toCss(val){
        let _leagueId = val.id, _hasDt = val['hasDt'];

        if(typeof(_leagueId) != 'undefined' && _hasDt){
          return '';
        }

        return 'league-title-hover';
      }
    },

    watch: {
      myLeague: {
        immediate: true,
        handler(val) {
          if(this.hotLeagues != val){
            this.getMyLeagueData();
          }
        }
      }
    }
  }
</script>

<style lang="less">
.my-league-wrapper{
  padding:20px 0;
  margin:0 16px;
  border-bottom:1px solid @color_D9D9D9;
  .league-title-icon{
    color:@color_FFB23F;
    font-size:22px;
    margin-right:6px;
  }
  .league-title-text{
    color:#000;
    font-size:16px;
    font-weight:600;
    font-family: @font_family_SF_Pro_Display;
    white-space: nowrap;
  }
  .league-list{
    li{
      margin-top:16px;
      img{
        width:18px;
        margin-right:8px;
      }
      span{
        color:@color_434343;
        font-size:14px;
        font-family: @font_family_SF_Pro_Display;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        line-clamp: 1;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        word-break: break-all;
        a{
          color:@color_434343;
          &:hover{
            text-decoration: underline;
          }
        }
      }
      .league-title-hover{
        cursor: default;
        &:hover{
          text-decoration: none;
        }
      }
    }
  }
}
/* phone */
@media screen and (max-width: 767px) {
  .my-league-wrapper{
    padding:.2rem 0;
    margin:0 .16rem;
    border-bottom-width:.01rem;
    .league-title-icon{
      font-size:.22rem;
      margin-right:.06rem;
    }
    .league-title-text{
      font-size:.16rem;
    }
    .league-list{
      li{
        margin-top:.16rem;
        img{
          width:.18rem;
          margin-right:.08rem;
        }
        span{
          font-size:.14rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/components/myLeague.vue